import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { CSAlertConfiguration } from "../Model/CSAlertConfiguration";

export async function createCSAlertConfiguration(data) {
	let response = await getAPIResponse("/v1/cs/alert-configuration", data, "POST");
	if (response === null) {
		return null;
	}
	let dataReturned = [];
	dataReturned.push(CSAlertConfiguration.createFromResponseData(response));
	return dataReturned;
}
